<mtg-table [stickyTop]="headerHeight" [showScrollArrows]="true">
  <mtg-table-header-row mtgSticky="top" [top]="headerHeight">
    <mtg-table-identity-col *ngIf="title">
      <div class="table-title">{{ title }}</div>
    </mtg-table-identity-col>
    <mtg-table-identity-col *ngIf="!title && identity">
      <ng-container *ngIf="['user', 'teamUser', 'tournamentTeamUser'].indexOf(identity) > -1">Игрок</ng-container>
      <ng-container *ngIf="['team', 'tournamentTeam'].indexOf(identity) > -1">Команда</ng-container>
    </mtg-table-identity-col>
    <ng-container *ngFor="let head of statisticHeader">
      <mtg-table-col-group *ngIf="head.data" [title]="head.title">
        <ng-container *ngFor="let col of head.data">
        <mtg-table-col
          *ngIf="!isTeamFieldExcluded(col.id)"
          [sortable]="true"
          (click)="changeSort(col.id)"
          [highlight]="sortTitle === col.id"
        >{{ col.title }}
        </mtg-table-col>
        </ng-container>
      </mtg-table-col-group>
      <mtg-table-col
        *ngIf="!head.data && !isTeamFieldExcluded(head.id)"
        [sortable]="true"
        (click)="changeSort(head.id)"
        [highlight]="sortTitle === head.id"
      >{{ head.title }}</mtg-table-col>
    </ng-container>
  </mtg-table-header-row>
  <ng-container *ngFor="let item of visibleStatistic; trackBy: trackById; let i = index;">
    <mtg-table-subtitle *ngIf="subTitle === 'month'">{{ item.month | date: 'MMM yyyy' }}</mtg-table-subtitle>
    <mtg-table-subtitle *ngIf="subTitle === 'winLoses'">
      <ng-container *ngIf="item.winLose === 'win'">Победы</ng-container>
      <ng-container *ngIf="item.winLose === 'lose'">Поражения</ng-container>
      <ng-container *ngIf="item.winLose === 'draw'">Ничьи</ng-container>
    </mtg-table-subtitle>
    <mtg-table-row>
      <mtg-table-identity-col *ngIf="identity">
        <div class="number">{{ i + 1 }}</div>
        <ng-container *ngIf="item.leaguePlayer && item.leaguePlayer.id && identity === 'leaguePlayer'">
          <div
            *ngIf="item.tournamentTeamUser && item.tournamentTeamUser.id"
            class="header-bg"
            [mtgTeamBg]="item.tournamentTeamUser.tournamentTeam.team.id"
          ></div>
          <div class="team-logo" *ngIf="teamLogoVisible">
            <img [src]="item.tournamentTeamUser.tournamentTeam.logo.path">
          </div>
          <div class="photo">
            <a [routerLink]="getLeaguePlayerRoute(item.leaguePlayer.id)"
               queryParamsHandling="preserve">
              <img [src]="item.leaguePlayer.photo.path" *ngIf="item.leaguePlayer.photo.path"
                   class="circle-image"/>
              <div class="empty-photo" *ngIf="!item.leaguePlayer.photo.path">
                {{ item.leaguePlayer.initials }}
              </div>
            </a>
          </div>
          <div class="info">
            <a [routerLink]="getLeaguePlayerRoute(item.leaguePlayer.id)"
               queryParamsHandling="preserve">
              <div class="name">{{ item.leaguePlayer.shortName }}<span
                *ngIf="item.tournamentTeamUser && item.tournamentTeamUser.teamUser.number"
                class="text-muted">&nbsp;#{{ item.tournamentTeamUser.teamUser.number }}</span></div>
              <div class="rating" *ngIf="item.leaguePlayer.rating">
                Индекс: {{ item.leaguePlayer.rating }}
              </div>
            </a>
          </div>
        </ng-container>
        <ng-container *ngIf="item.tournamentTeamUser && item.tournamentTeamUser.id && identity === 'tournamentTeamUser'">
          <div class="header-bg" [mtgTeamBg]="item.tournamentTeamUser.tournamentTeam.team.id"></div>
          <div class="team-logo" *ngIf="teamLogoVisible">
            <img [src]="item.tournamentTeamUser.tournamentTeam.team.logo.path">
          </div>
          <div class="photo">
            <a [routerLink]="getLeaguePlayerRoute(item.tournamentTeamUser.leaguePlayer.id)"
               queryParamsHandling="preserve">
              <img [src]="item.tournamentTeamUser.leaguePlayer.photo.path" *ngIf="item.tournamentTeamUser.leaguePlayer.photo.path"
                   class="circle-image"/>
              <div class="empty-photo" *ngIf="!item.tournamentTeamUser.leaguePlayer.photo.path">
                {{ item.tournamentTeamUser.leaguePlayer.initials }}
              </div>
            </a>
          </div>
          <div class="info">
            <a [routerLink]="getLeaguePlayerRoute(item.tournamentTeamUser.leaguePlayer.id)"
               queryParamsHandling="preserve">
              <div class="name">{{ item.tournamentTeamUser.leaguePlayer.shortName }}<span
                *ngIf="item.tournamentTeamUser.teamUser.number"
                class="text-muted">&nbsp;#{{ item.tournamentTeamUser.teamUser.number }}</span></div>
              <div class="rating" *ngIf="item.tournamentTeamUser.leaguePlayer.rating">
                Индекс: {{ item.tournamentTeamUser.leaguePlayer.rating }}
              </div>
            </a>
          </div>
        </ng-container>
        <ng-container *ngIf="item.teamUser && item.teamUser.id && identity === 'teamUser'">
          <div class="header-bg" [mtgTeamBg]="item.teamUser.team.id"></div>
          <div class="team-logo" *ngIf="teamLogoVisible">
            <img [src]="item.teamUser.team.logo.path">
          </div>
          <div class="photo">
            <a [routerLink]="getLeaguePlayerRoute(item.leaguePlayer.id)"
               queryParamsHandling="preserve">
              <img [src]="item.leaguePlayer.photo.path" *ngIf="item.leaguePlayer.photo.path"
                   class="circle-image"/>
              <div class="empty-photo" *ngIf="!item.leaguePlayer.photo.path">
                {{ item.leaguePlayer.initials }}
              </div>
            </a>
          </div>
          <div class="info">
            <a [routerLink]="getLeaguePlayerRoute(item.leaguePlayer.id)"
               queryParamsHandling="preserve">
              <div class="name">{{ item.leaguePlayer.shortName }}<span
                *ngIf="item.teamUser.number"
                class="text-muted">&nbsp;#{{ item.teamUser.number }}</span></div>
              <div class="rating" *ngIf="item.leaguePlayer.rating">
                Индекс: {{ item.leaguePlayer.rating }}
              </div>
            </a>
          </div>
        </ng-container>
        <ng-container *ngIf="item.tournamentTeam && item.tournamentTeam.id">
          <div class="header-bg" [mtgTeamBg]="item.tournamentTeam.team.id"></div>
          <div class="photo">
            <a [routerLink]="getTeamRoute(item.tournamentTeam.team.id)" queryParamsHandling="preserve">
              <img [src]="item.tournamentTeam.team.logo.path" *ngIf="item.tournamentTeam.team.logo.path"/>
              <div [ngClass]="item.tournamentTeam.team.getEmptyLogoClass()"
                   *ngIf="!item.tournamentTeam.team.logo.path"></div>
            </a>
          </div>
          <div class="info">
            <a [routerLink]="getTeamRoute(item.tournamentTeam.team.id)" queryParamsHandling="preserve">
              <div class="name">{{ item.tournamentTeam.team.name }}</div>
            </a>
          </div>
        </ng-container>
        <ng-container *ngIf="item.team && item.team.id">
          <div class="photo">
            <a [routerLink]="getTeamRoute(item.team.id)" queryParamsHandling="preserve">
              <img [src]="item.team.logo.path" *ngIf="item.team.logo.path"/>
              <div [ngClass]="item.team.getEmptyLogoClass()" *ngIf="!item.team.logo.path"></div>
            </a>
          </div>
          <div class="info">
            <a [routerLink]="getTeamRoute(item.team.id)" queryParamsHandling="preserve">
              <div class="name">{{ item.team.name }}</div>
            </a>
          </div>
        </ng-container>
      </mtg-table-identity-col>
      <ng-container *ngFor="let head of statisticHeader">
        <mtg-table-col-group *ngIf="head.data" [title]="head.title">
          <ng-container *ngFor="let col of head.data">
            <mtg-table-col *ngIf="!isTeamFieldExcluded(col.id)" [highlight]="sort === col.id">
              {{ floatValue(item[col.id] || 0) }}{{ col.percent ? '%' : '' }}
            </mtg-table-col>
          </ng-container>
        </mtg-table-col-group>
        <mtg-table-col [highlight]="sort === head.id" *ngIf="!head.data && !isTeamFieldExcluded(head.id)">
          {{ floatValue(item[head.id] || 0) }}{{ head.percent ? '%' : '' }}
        </mtg-table-col>
      </ng-container>
    </mtg-table-row>
  </ng-container>
</mtg-table>
<div class="loading" *ngIf="!statistic">
  <mtg-spinner></mtg-spinner>
</div>

<div class="next-page" *ngIf="nextPageVisible">
  <mtg-button (click)="nextPage()">Показать еще</mtg-button>
</div>
